(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"] && !Shopify.designMode) return;
  try {
    
    document.addEventListener("DOMContentLoaded", function() {
    var endlessScroll = new Ajaxinate({
      container: '#AjaxinateContainer',
      pagination: '#AjaxinatePagination',
      method: 'scroll',
      offset: 1000,
      //callback : loadstampedreviews
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-contact"] && !Shopify.designMode) return;
  try {
    
(function($) {
    $(document).ready(function() {
        $("form#contactUs-Form").on('submit', function(e) {
            e.preventDefault();
            let isValid = true;
            const required = ['first_name', 'last_name', 'message'];
            const $submitButton = $("button[type='submit']");

            // Validate required fields
            for (const field of required) {
                const input = $('#' + field);
                const placeholderText = input.attr("placeholder");
                if (input.val() === "" || input.val() === "Please fill out this field.") {
                    input.addClass("needsfilled error").attr("placeholder", placeholderText);
                    isValid = false;
                } else {
                    input.removeClass("needsfilled");
                }
            }

            const namePattern = /^(?!.*\d)([a-zA-Z\xC0-\uFFFF]{3,20}([ \-']{0,1}[a-zA-Z\xC0-\uFFFF]{3,20})*[.]{0,1}){1,2}$/;

            // First name validation
            const firstNameInput = $('#first_name');
            const firstNameValue = firstNameInput.val();
            if (!namePattern.test(firstNameValue)) {
                firstNameInput.addClass("needsfilled error").attr("placeholder", "First Name");
                isValid = false;
            } else {
                firstNameInput.removeClass("needsfilled");
            }

            // Last name validation
            const lastNameInput = $('#last_name');
            const lastNameValue = lastNameInput.val();
            if (!namePattern.test(lastNameValue)) {
                lastNameInput.addClass("needsfilled error").attr("placeholder", "Last Name");
                isValid = false;
            } else {
                lastNameInput.removeClass("needsfilled");
            }

            // Email validation
            const email = $("#customer_email");
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            if (!emailRegex.test(email.val())) {
                email.addClass("needsfilled error").attr("placeholder", "Please enter a valid e-mail.");
                isValid = false;
            }

            // Handle form submission if valid
            if (isValid) {
                $submitButton.text("Submitting...").prop("disabled", true);

                let formDataArray = $(this).serializeArray();
                // Remove any blank fields from formDataArray
                formDataArray = formDataArray.filter(function(field) {
                    return field.value.trim() !== "";
                });

                const formData = {};
                formDataArray.forEach(function(item) {
                    formData[item.name] = item.value;
                });

                console.log("Check Form Data", formData);

                $.ajax({
                    type: 'POST',
                    url: "",
                    data: formData,
                    success: function(response) {
                        try {
                            function isJSON(response) {
                                try {
                                    JSON.parse(response);
                                    return true;
                                } catch (e) {
                                    return false;
                                }
                            }

                            if (isJSON(response)) {
                                const parsedResponse = JSON.parse(response);
                                if (parsedResponse.errors && Object.keys(parsedResponse.errors).length > 0) {
                                    let errorList = $('<ul>');
                                    for (const [field, messages] of Object.entries(parsedResponse.errors)) {
                                        if (Array.isArray(messages)) {
                                            messages.forEach(message => {
                                                errorList.append(`<li>${message}</li>`);
                                            });
                                        } else {
                                            errorList.append(`<li>${messages}</li>`);
                                        }
                                    }

                                    $('.error-message').html(errorList);
                                    $submitButton.text("Submit").prop("disabled", false); // Re-enable button on error
                                } else {
                                    console.log('Form submitted successfully.');
                                    $('.error-message').html('');
                                }
                            } else {
                                throw new Error('Response is not valid JSON');
                            }
                        } catch (e) {
                            console.error('Error parsing response:', e, "Response:", response);
                            $('.error-message').html('An unexpected error occurred. Please try again.');
                            $submitButton.text("Submit").prop("disabled", false);
                        }
                    },
                    error: function(xhr, status, error) {
                        console.error('An error occurred. Please try again.', error);
                        $('.error-message').html('An error occurred. Please try again.');
                        $submitButton.text("Submit").prop("disabled", false);
                    }
                });
            } else {
                $submitButton.text("Submit").prop("disabled", false);
            }
        });

        // Handle input focus to clear error styling
        $(":input").focus(function() {
            if ($(this).hasClass("needsfilled")) {
                $(this).val("");
                $(this).removeClass("needsfilled error");
            }
        });
    });
})(jQuery);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-search"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener("DOMContentLoaded", function() {
      var endlessScroll = new Ajaxinate({
        container: '#AjaxinateContainer',
        pagination: '#AjaxinatePagination',
        method: 'scroll',
        offset: 1000
         //callback : loadstampedreviews
      });
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-key-ingredients"] && !Shopify.designMode) return;
  try {
    
                                //Flip Swiper Slider
  $(document).ready(function () {
        var flipSwiper = new Swiper(".swiper-flip", {
            grabCursor: false,
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
            pagination: {
                el: ".swiper-pagination",
                clickable: true
            },
            loop: false,
            effect: "creative",
            slidesPerView: 1.1,
            loopedSlides: 1.1,
            observer: true,
            creativeEffect: {
                limitProgress: 2,
                prev: {
                    shadow: true,
                    translate: ["-105%", 0, -250],
                },
                next: {
                    shadow: true,
                    translate: ["20%", 0, -250],
                },
            },
            breakpoints: {
                640: {
                    slidesPerView: 1.25,
                    spaceBetween: 20,
                }
            }
        });

  // flipSwiper.on('slideChangeTransitionEnd', () => {
  //     document.querySelectorAll('.swiper-flip .swiper-slide:not(.swiper-slide-active) .ingredient-flip-card.flipped').forEach((fItem) => {
  //         fItem.classList.remove('flipped');
  //     });
  // });

  // $('.ingredient-flip-card').click(function () {
  //     $(this).toggleClass('flipped');
  // });
        $(window).scroll(function () {
            if ($(this).scrollTop() > 500) {
                $('#product_offer').addClass('product_offer--active');
            } else {
                $('#product_offer').removeClass('product_offer--active');
            }
        });
  });

  } catch(e) { console.error(e); }
})();
})();
